/**
 * Ítems de la lista que alimenta un campo de tipo `list`.
 *
 * Es la misma resolución que usa el render del valor para armar la etiqueta jerárquica:
 * `listRef` (lista por referencia), `listType` (lista interna) o, si el campo no declara
 * ninguna, la lista cuyo `type` coincide con la clave del campo.
 *
 * @param {{listRef?:string, listType?:string, key?:string}} field
 * @param {{lists?:Array, referenceItems?:Object}} sources
 * @returns {Array<{_id?:string, label?:string, parent?:string, color?:string}>}
 */
export function getFieldListItems(field, { lists = [], referenceItems = {} } = {}) {
  if (!field) return [];

  if (field.listRef && referenceItems && referenceItems[field.listRef]) {
    return referenceItems[field.listRef] || [];
  }

  const all = Array.isArray(lists) ? lists : [];
  const byType = field.listType
    ? all.find((l) => l && l.type === field.listType)
    : null;
  if (byType && byType.values) return byType.values;

  const byKey = field.key ? all.find((l) => l && l.type === field.key) : null;
  if (byKey && byKey.values) return byKey.values;

  return [];
}
